export default "../../src/img/icon-256x256.png";